import React from 'react';

const Badge = ({ variant = 'info', children, className = '' }) => {
  const styles = {
    active: 'bg-emerald-500/10 text-emerald-600 border-emerald-500/20',
    success: 'bg-emerald-500/10 text-emerald-600 border-emerald-500/20',
    pending: 'bg-amber-500/10 text-amber-600 border-amber-500/20',
    inactive: 'bg-slate-500/10 text-slate-500 border-slate-500/20',
    suspended: 'bg-rose-500/10 text-rose-600 border-rose-500/20',
    danger: 'bg-rose-500/10 text-rose-600 border-rose-500/20',
    info: 'bg-emerald-500/10 text-emerald-600 border-emerald-500/20'
  };

  const selectedStyle = styles[variant.toLowerCase()] || styles.info;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${selectedStyle} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
